import { GlobalStyle } from './styles/GlobalStyle';
import Router from './Router';

export default function App() {
  return (
    <>
      <GlobalStyle />
      <Router />
    </>
  );
}
